<template>
  <div class="messenger-manager p-3">
    <el-card shadow="always" class="messengers-card">
      <template #header>
        <el-row justify="space-between" align="middle" class="messengers-toolbar">
          <div>
            <b>Управление мессенджерами</b>
          </div>
          <el-button type="primary" size="small" @click="openAddMessenger">Добавить мессенджер</el-button>
        </el-row>
      </template>

      <div class="messengers-table-shell">
        <el-table :data="messengers" style="width: 100%;" v-loading="loading">
        <el-table-column prop="type" label="Тип" width="120"></el-table-column>
        <el-table-column prop="display_name" label="Имя профиля"></el-table-column>
        <el-table-column prop="external_id" label="Номер/логин"></el-table-column>
        <el-table-column prop="auth_status" label="Авторизация" width="150">
          <template #default="scope">
            <el-tag :type="scope.row.auth_status === 'authorized' ? 'success' : 'warning'">
              {{ scope.row.auth_status === 'authorized' ? 'Авторизован' : 'Не авторизован' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="active_status" label="Активность" width="150">
          <template #default="scope">
            <el-tag :type="scope.row.active_status === 'active' ? 'success' : 'info'">
              {{ scope.row.active_status === 'active' ? 'Включен' : 'Выключен' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="right">
          <template #default="scope">
            <el-button
              v-if="scope.row.auth_status === 'unauthorized' && (scope.row.type === 'telegram' || scope.row.type === 'whatsapp')"
              size="small"
              type="primary"
              @click="authorizeMessenger(scope.row)"
            >
              Авторизовать
            </el-button>
            <el-button
              v-else-if="scope.row.auth_status === 'authorized' && scope.row.active_status === 'inactive'"
              size="small"
              type="success"
              @click="changeActiveStatus(scope.row, 'active')"
            >
              Включить
            </el-button>
            <el-button
              v-else-if="scope.row.auth_status === 'authorized' && scope.row.active_status === 'active'"
              size="small"
              type="warning"
              @click="changeActiveStatus(scope.row, 'inactive')"
            >
              Выключить
            </el-button>
            <el-button
              v-if="scope.row.auth_status === 'authorized'"
              size="small"
              type="primary"
              @click="editMessengerRoles(scope.row)"
            >
              Редактировать доступ
            </el-button>
            <el-button size="small" type="danger" @click="confirmRemoveMessenger(scope.row)" circle :icon="Delete" />
          </template>
        </el-table-column>
        </el-table>
      </div>
    </el-card>

    <!-- Диалог добавления -->
    <el-dialog v-model="addDialogVisible" title="Добавить мессенджер" class="messengers-dialog col-md-4 col-11">
      <el-form :model="newMessenger">
        <el-form-item label="Тип мессенджера">
          <el-select v-model="newMessenger.type" placeholder="Выберите тип" class="messenger-select">
            <el-option value="whatsapp" label="WhatsApp" disabled>
              <template #default>
                <div class="out-icon-wrap">
                  <font-awesome-icon class="out-icon--whatsapp" :icon="['fab', 'whatsapp']" />
                  <span class="option-label">WhatsApp (временно недоступен)</span>
                </div>
              </template>
            </el-option>

            <el-option
              value="telegram"
              label="Telegram"
              class="messenger-select"
            >
              <template #default>
                <div class="out-icon-wrap">
                  <font-awesome-icon class="out-icon--telegram" :icon="['fab', 'telegram']" />
                  <span class="option-label">Telegram</span>
                </div>
              </template>
            </el-option>

            <el-option value="email" label="Email">
              <template #default>
                <div class="out-icon-wrap">
                  <font-awesome-icon class="out-icon--email" :icon="['fas', 'envelope']" />
                  <span class="option-label">Email</span>
                </div>
              </template>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="addDialogVisible = false">Отмена</el-button>
        <el-button type="primary" @click="startMessengerAuth">Далее</el-button>
      </template>
    </el-dialog>

    <!-- Модальное окно с QR (для WhatsApp) -->
    <el-dialog v-model="qrDialogVisible" title="Сканируйте QR для авторизации" class="messengers-dialog col-md-4 col-11">
      <div v-if="qrCode" class="text-center">
        <img :src="'data:image/png;base64,' + qrCode" alt="QR Code" style="max-width: 250px;" />
      </div>
      <div v-else class="text-center text-muted">
        Ожидание QR кода...
      </div>
      <template #footer>
        <el-button @click="cancelAuth">Отмена</el-button>
      </template>
    </el-dialog>
    <!-- Диалог настройки доступа к мессенджеру -->
    <MessengerRolesDialog
      v-model="rolesDialogVisible"
      :messenger-id="currentMessengerId"
      v-if="rolesDialogVisible"
    />
    <EmailSettingsDialog
      v-model="emailDialogVisible"
      @saved="fetchMessengers"
    />
    <!-- Диалог авторизации Telegram -->
    <el-dialog v-model="telegramDialogVisible" title="Авторизация Telegram" class="messengers-dialog col-md-4 col-11">
      <el-form :model="telegramAuth" v-if="!telegramWait.active">
        <el-form-item label="Номер телефона">
          <vue-tel-input
            v-bind="bindProps"
            v-model="telegramAuth.phone"
            :format-on-display="true"
            :mode="'international'"
            :preferred-countries="['ru', 'by', 'kz']"
            :disabled="telegramAuth.step !== 'phone'"
            @validate="handlePhoneValidation"
          />
        </el-form-item>
        <el-form-item v-if="telegramAuth.step === 'code'" label="Код из Telegram">
          <el-input v-model="telegramAuth.code" placeholder="Введите код" />
        </el-form-item>
      </el-form>

      <div v-else class="text-center py-4">
        <p>Telegram временно ограничил авторизацию.</p>
        <el-progress
          :percentage="(telegramWait.secondsInitial - telegramWait.seconds) / telegramWait.secondsInitial * 100"
          :text-inside="true"
          :stroke-width="18"
          status="warning"
          :format="() => 'Ожидание ' + telegramWait.seconds + ' сек.'"
        />
      </div>

      <template #footer>
        <el-button @click="telegramDialogVisible = false">Отмена</el-button>
        <el-button type="primary" @click="submitTelegramAuth">
          {{ telegramAuth.step === 'phone' ? 'Отправить код' : 'Войти' }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Delete } from '@element-plus/icons-vue'
import MessengerRolesDialog from '@/components/util/dialogs/MessengerRolesDialog.vue'
import EmailSettingsDialog from '@/components/views/modal/EmailSettingsDialog.vue'
import { eventBus } from '@/components/util/eventBus'
import 'vue-tel-input/vue-tel-input.css'
import auth from '@/components/store/modules/auth'

export default {
  name: 'MessengerManager',
  components: {
    MessengerRolesDialog,
    EmailSettingsDialog
  },
  data() {
    return {
      bindProps: {
        inputOptions: {
          placeholder: 'Введите номер'
        }
      },
      loading: false,
      addDialogVisible: false,
      qrDialogVisible: false,
      newMessenger: { type: '' },
      currentMessengerId: null,
      rolesDialogVisible: false,
      emailDialogVisible: false,
      telegramDialogVisible: false,
      telegramAuth: { phone: '', code: '', step: 'phone' },
      telegramWait: { active: false, phone: '', seconds: 0, secondsInitial: 0, timer: null },
      telegramValid: false
    }
  },
  computed: {
    auth() {
      return auth
    },
    Delete() {
      return Delete
    },
    ...mapState('messengers', ['messengers']),
    ...mapState('socket', ['qrCode', 'whatsappReadyStatuses'])
  },
  methods: {
    ...mapActions('users', ['getUsers']),
    ...mapActions('messengers', ['fetchMessengers', 'toggleMessengerStatus', 'initiateMessengerAuth', 'removeMessenger']),
    openAddMessenger() {
      this.newMessenger = { type: '' }
      this.addDialogVisible = true
    },
    async startMessengerAuth() {
      if (this.newMessenger.type === 'whatsapp') {
        this.$notify({ type: 'warning', message: 'WhatsApp временно недоступен в РФ' })
        return
      } else if (this.newMessenger.type === 'email') {
        this.addDialogVisible = false
        this.emailDialogVisible = true
      } else if (this.newMessenger.type === 'telegram') {
        this.addDialogVisible = false
        this.telegramDialogVisible = true
        this.telegramAuth = { phone: '', code: '', step: 'phone' }
      }
    },
    authorizeMessenger(messenger) {
      this.currentMessengerId = messenger.id

      if (messenger.type === 'whatsapp') {
        this.qrDialogVisible = true
        this.$store.dispatch('socket/send', {
          event: 'whatsapp-start-auth',
          data: { messenger_id: messenger.id }
        })
      } else if (messenger.type === 'telegram') {
        this.telegramDialogVisible = true

        this.telegramAuth = {
          phone: messenger.external_id, // vue-tel-input сам подставит +7 для выбранной страны
          code: '',
          step: 'phone'
        }
        this.telegramAuth.isReauth = messenger.auth_status === 'unauthorized';
        this.$nextTick(() => {
          // Надёжное обновление vue-tel-input: сбрасываем и возвращаем номер
          const oldPhone = this.telegramAuth.phone
          this.telegramAuth.phone = ''
          this.$nextTick(() => {
            this.telegramAuth.phone = oldPhone
          })
        })
      }
    },
    changeActiveStatus(messenger, status) {
      this.$confirm(
        `Вы действительно хотите ${status === 'active' ? 'включить' : 'выключить'} мессенджер "${messenger.display_name || messenger.id}"?`,
        'Подтверждение действия',
        {
          confirmButtonText: status === 'active' ? 'Включить' : 'Выключить',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }
      )
        .then(() => {
          this.toggleMessengerStatus({
            messengerId: messenger.id,
            status_type: 'active_status',
            status_value: status
          })
            .then(() => {
              this.$notify({ message: `Мессенджер ${status === 'active' ? 'включен' : 'выключен'}`, type: 'success' })
              this.fetchMessengers()
            })
            .catch(() => {
              this.$notify({ message: 'Ошибка обновления статуса', type: 'error' })
              this.fetchMessengers()
            })
        })
        .catch(() => {
          this.$notify({ type: 'info', message: 'Изменение статуса отменено' })
        })
    },
    confirmRemoveMessenger(messenger) {
      this.$confirm(
        `Вы действительно хотите удалить мессенджер "${messenger.display_name || messenger.id}"?`,
        'Подтверждение удаления',
        {
          confirmButtonText: 'Удалить',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }
      )
        .then(() => {
          this.removeMessenger({ messengerId: messenger.id })
            .then(() => {
              this.$notify({ message: 'Мессенджер успешно удалён', type: 'success' })
              if (messenger.type === 'telegram') {
                this.$store.dispatch('socket/send', {
                  event: 'telegram:delete-messenger',
                  data: { phone: messenger.external_id }
                })
              }
            })
            .catch(() => {
              this.$notify({ message: 'Ошибка при удалении мессенджера', type: 'error' })
            })
        })
        .catch(() => {
          this.$notify({ type: 'info', message: 'Удаление отменено' })
        })
    },
    cancelAuth() {
      this.qrDialogVisible = false
    },
    editMessengerRoles(messenger) {
      this.currentMessengerId = messenger.id
      this.rolesDialogVisible = true
    },
    async submitTelegramAuth() {
      if (this.telegramAuth.step === 'phone') {
        if (!this.telegramAuth.phone) {
          this.$notify({ type: 'warning', message: 'Введите номер телефона' })
          return
        }

        const formattedPhone = this.telegramAuth.phone.replace(/\s+/g, '')

        const eventName = this.telegramAuth.isReauth ? 'telegram:reauthorize' : 'telegram:login';

        console.debug('eventName -> ', eventName)

        this.$store.dispatch('socket/send', {
          event: eventName,
          data: { phone: formattedPhone }
        });
        this.telegramAuth.step = 'code'
        this.$notify({ type: 'info', message: 'Введите код из Telegram' })
      } else if (this.telegramAuth.step === 'code') {
        if (!this.telegramAuth.code) {
          this.$notify({ type: 'warning', message: 'Введите код' })
          return
        }

        const formattedPhone = this.telegramAuth.phone.replace(/\s+/g, '')

        console.debug('send code -> ', this.telegramAuth.code)

        this.$store.dispatch('socket/send', {
          event: 'telegram:submit-code',
          data: {
            phone: formattedPhone,
            code: this.telegramAuth.code
          }
        })
      }
    },
    handlePhoneValidation(isValid) {
      this.isPhoneComplete = isValid.valid
    },
  }
  ,
  mounted() {
    this.getUsers()
    this.loading = true
    this.fetchMessengers().finally(() => {
      this.loading = false
    })
    // === Слушаем событие успешной авторизации Telegram ===
    eventBus.on('telegram-authorized', ({ phone }) => {
      this.telegramDialogVisible = false
      this.$notify({
        title: 'Telegram',
        message: `Telegram (${phone}) успешно авторизован`,
        type: 'success',
        duration: 4000
      })
      this.fetchMessengers()
    })

    eventBus.on('telegram-wait', ({ phone, waitSeconds }) => {
      console.log(`[TELEGRAM] FLOOD_WAIT ${waitSeconds}s для ${phone}`)
      this.telegramWait.active = true
      this.telegramWait.phone = phone
      this.telegramWait.seconds = waitSeconds
      this.telegramWait.secondsInitial = waitSeconds

      if (this.telegramWait.timer) clearInterval(this.telegramWait.timer)
      this.telegramWait.timer = setInterval(() => {
        if (this.telegramWait.seconds > 0) {
          this.telegramWait.seconds--
        } else {
          clearInterval(this.telegramWait.timer)
          this.telegramWait.active = false
        }
      }, 1000)
    })

    eventBus.on('telegram-code-request', ({ phone }) => {
      console.log(`[TELEGRAM] Код запрошен для ${phone}`)
      this.telegramAuth.step = 'code'
      this.$notify({ type: 'info', message: 'Введите код из Telegram' })
    })
  }
  ,
  beforeUnmount() {
    eventBus.off('telegram-authorized')
    if (this.telegramWait.timer) clearInterval(this.telegramWait.timer)
    eventBus.off('telegram-wait')
    eventBus.off('telegram-code-request')
  }
  ,
  watch: {
    whatsappReadyStatuses: {
      handler(statuses) {
        if (this.currentMessengerId && statuses[this.currentMessengerId]) {
          this.qrDialogVisible = false // Закрываем окно QR
          // Обновим список и откроем диалог ролей ТОЛЬКО после успешной авторизации
          this.fetchMessengers().finally(() => {
            this.rolesDialogVisible = true
            this.$notify({
              type: 'success',
              message: 'Мессенджер успешно авторизован и готов к работе. Настройте доступ.'
            })
          })
        }
      }
      ,
      deep: true
    }
    ,
    '$store.state.socket.lastEvent'(event) {
      if (!event) return
      const { type, data } = event
      if (type === 'telegram:authorized') {
        this.telegramDialogVisible = false
        this.$notify({ type: 'success', message: 'Telegram успешно авторизован!' })
        this.fetchMessengers()
      }
      if (type === 'telegram:error') {
        this.$notify({ type: 'error', message: data })
      }
    }
  }
}
</script>


<style scoped>
.messenger-manager {
  overflow: auto;
  height: 100%;
  padding: 24px 18px 28px !important;
  background:
    radial-gradient(circle at top left, rgba(22, 61, 124, 0.28), transparent 34%),
    linear-gradient(180deg, #091325 0%, #07111f 100%);
}

.messengers-card {
  border: 1px solid rgba(110, 146, 214, 0.18);
  border-radius: 24px;
  background: linear-gradient(180deg, rgba(10, 26, 52, 0.96), rgba(7, 18, 36, 0.94));
  box-shadow: 0 24px 48px rgba(2, 8, 18, 0.34);
}

.messengers-card :deep(.el-card__header),
.messengers-card :deep(.el-card__body) {
  background: transparent;
}

.messengers-card :deep(.el-card__header) {
  border-bottom-color: rgba(174, 194, 230, 0.08);
}

.messengers-card :deep(.el-card__body) {
  padding-top: 8px;
}

.messengers-toolbar {
  gap: 12px;
}

.messengers-toolbar b {
  color: #eef5ff;
  font-weight: 700;
}

.messengers-table-shell {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.messenger-manager :deep(.el-table),
.messenger-manager :deep(.el-table__expanded-cell),
.messenger-manager :deep(.el-table tr),
.messenger-manager :deep(.el-table th.el-table__cell),
.messenger-manager :deep(.el-table td.el-table__cell) {
  background: #08172f !important;
  color: #d7e7ff !important;
  border-bottom-color: rgba(174, 194, 230, 0.1) !important;
}

.messenger-manager :deep(.el-table) {
  --el-table-border-color: rgba(174, 194, 230, 0.1);
  --el-table-header-bg-color: #0e2447;
  --el-table-row-hover-bg-color: rgba(0, 195, 254, 0.08);
  border: 1px solid rgba(110, 146, 214, 0.12);
  border-radius: 18px;
  overflow: hidden;
}

.messenger-manager :deep(.el-table th.el-table__cell) {
  color: rgba(174, 194, 230, 0.72) !important;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.messenger-manager :deep(.el-button--primary) {
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #00c3fe, #2b7cff);
}

.messengers-dialog.el-dialog {
  width: min(560px, calc(100vw - 24px)) !important;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid rgba(110, 146, 214, 0.2);
  background: linear-gradient(180deg, rgba(12, 28, 55, 0.98), rgba(7, 18, 36, 0.98));
}

.messengers-dialog :deep(.el-dialog__header),
.messengers-dialog :deep(.el-dialog__body),
.messengers-dialog :deep(.el-dialog__footer) {
  background: transparent;
}

.messengers-dialog :deep(.el-dialog__title),
.messengers-dialog :deep(.el-form-item__label) {
  color: #eef5ff;
}

.messengers-dialog :deep(.el-input__wrapper),
.messengers-dialog :deep(.el-select__wrapper),
.messengers-dialog :deep(.vue-tel-input) {
  background: rgba(10, 26, 52, 0.96) !important;
  box-shadow: inset 0 0 0 1px rgba(110, 146, 214, 0.16) !important;
}

.messengers-dialog :deep(.el-input__inner),
.messengers-dialog :deep(.el-select__placeholder),
.messengers-dialog :deep(.vti__input) {
  color: #eef5ff !important;
}

.text-center {
  text-align: center;
}

.text-muted {
  color: var(--ui-color-text-dim);
}

.messenger-select .el-icon {
  margin-right: 8px;
  vertical-align: middle;
}

.option-label {
  vertical-align: middle;
}

.messenger-select .el-select-dropdown__item {
  display: flex;
  align-items: center;
}

.messenger-select .out-icon {
  margin-right: 8px;
  font-size: 20px;
  width: 24px;
  text-align: center;
  vertical-align: middle;
}

.out-icon-wrap {
  display: flex;
  align-items: center;
}

/* Цвета по брендам */
.out-icon-wrap .out-icon--whatsapp {
  color: #25D366;
  height: 20px;
  margin-right: 5px;
}

.out-icon-wrap .out-icon--telegram {
  color: #229ED9;
  height: 20px;
  margin-right: 5px;
}

.out-icon-wrap .out-icon--email {
  color: #b3b3b3;
  height: 20px;
  margin-right: 5px;
}

.option-label {
  vertical-align: middle;
  font-size: 16px;
  color: #d7e7ff;
}

@media (max-width: 768px) {
  .messenger-manager {
    padding: 16px 12px 22px !important;
  }

  .messengers-toolbar {
    flex-direction: column;
    align-items: stretch !important;
  }

  .messengers-toolbar b {
    text-align: center;
  }

  .messengers-table-shell {
    overflow-x: auto;
  }

  .messenger-manager :deep(.el-table) {
    min-width: 720px;
  }

  .messenger-manager :deep(.el-table th.el-table__cell),
  .messenger-manager :deep(.el-table td.el-table__cell) {
    white-space: nowrap !important;
  }
}
</style>
